import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./SimApp.css";
import Footer from "./components/Footer";
import Header from "./components/Header";

const params = new URLSearchParams(window.location.search);
const isEmail = params.get('source') === 'email';

const API_BASE_URL = isEmail
  ? 'http://127.0.0.1:5000'          // Puppeteer on server → localhost
  : 'http://180.211.162.102:5000'; 

export default function SimApp() {
  const [formData, setFormData] = useState({
    applicant_subject: "",
    inst_name: "",
    inst_code: "",
    inst_eiin: "",
    inst_name_eiin: "",
    contact_number: "",
    applicant_name: "",
    designation: "",
    mobile_no: "",
    email: "",
    image: null,
    nid_no: "",
    nid_image: null,
    gd_image: null
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Get auth and institute data from localStorage
    const auth = JSON.parse(localStorage.getItem("auth"));
    const instituteData = JSON.parse(localStorage.getItem("instituteData"));
    
    // Check if user is logged in as institute
    if (!auth) {
      // No auth data, redirect to login
      navigate("/");
      return;
    }
    
    if (auth.role !== "Institute") {
      // Not an institute user, redirect based on role
      if (auth.isAdmin) {
        navigate("/ViewSentApplication");
      } else {
        navigate("/");
      }
      return;
    }
    
    // Set institute data from localStorage
    if (instituteData) {
      setFormData((prev) => ({
        ...prev,
        inst_name: instituteData.INST_NAME || "",
        inst_code: instituteData.INST_ID || "",
        inst_eiin: instituteData.EIIN || "",
        contact_number: instituteData.MOBILE_NO || "",
        email: ""
      }));
    }
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }

    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.applicant_subject) {
      newErrors.applicant_subject = "আবেদনের বিষয় নির্বাচন করুন";
    }
    if (!formData.applicant_name.trim()) {
      newErrors.applicant_name = "আবেদনকারীর নাম দিন";
    }
    if (!formData.designation.trim()) {
      newErrors.designation = "আবেদনকারীর পদবি দিন";
    }
    if (!formData.mobile_no.trim()) {
      newErrors.mobile_no = "মোবাইল নম্বর দিন";
    } else if (!/^(?:\+88|01)\d{9}$/.test(formData.mobile_no)) {
      newErrors.mobile_no = "সঠিক মোবাইল নম্বর দিন";
    }
    // Email validation
    if (!formData.email.trim()) {
      newErrors.email = "ইমেইল দিন";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "সঠিক ইমেইল দিন";
    }
    if (!formData.image) {
      newErrors.image = "আবেদনকারীর ছবি আপলোড করুন";
    }
    if (!formData.nid_no.trim()) {
      newErrors.nid_no = "এন.আই.ডি নম্বর দিন";
    } else if (!/^\d{6,17}$/.test(formData.nid_no)) {
      newErrors.nid_no = "সঠিক এন.আই.ডি নম্বর দিন (৬-১৭ ডিজিট)";
    }
    if (!formData.nid_image) {
      newErrors.nid_image = "এন.আই.ডি এর ছবি আপলোড করুন";
    }
    if (formData.applicant_subject === "lost_sim_reissue" && !formData.gd_image) {
      newErrors.gd_image = "জিডি কপি আপলোড করুন";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      alert("দয়া করে সব প্রয়োজনীয় তথ্য পূরণ করুন");
      return;
    }

    localStorage.setItem("isAdminViewingTemp", "false");

    // ✅ Show loading state
    setIsLoading(true);

    console.log("🌐 API_BASE:", API_BASE_URL);

    try {
      //Prepare email recipients array including the applicant's email
      const emailRecipients = [
        "service_enterprise@grameenphone.com",
        "mahfujhassan7658@gmail.com",
        "kibria.carzon@gmail.com", 
        formData.email,
        "abdullah.mahmud@grameenphone.com", 
        "ame@bteb.gov.bd"
      ];

    // const emailRecipients = [
    //     "mahfujhassan7658@gmail.com",
    //     "mahfujhassan14@gmail.com"
    //   ];

      // 1️⃣ Prepare form data for database insert
      const submitData = new FormData();
      Object.keys(formData).forEach((key) => {
        submitData.append(key, formData[key]);
      });

      // 2️⃣ Add current date
      const now = new Date();
      const bstOffset = 6 * 60; // Bangladesh is UTC+6 hours = 360 minutes
      const bstDate = new Date(now.getTime() + bstOffset * 60 * 1000);
      const currentDate = bstDate.toISOString().split('T')[0];
      submitData.append('apply_date', currentDate);

      // 3️⃣ Send form data to backend
      const res = await fetch(`${API_BASE_URL}/api/sim-application`, {
        method: "POST",
        body: submitData
      });

      const data = await res.json();

      if (!data.success) {
        setIsLoading(false); // ✅ Hide loading on error
        alert("Failed: " + data.message);
        return;
      }
      console.log("✅ sim-application response:", data);

      // 4️⃣ Generate PDF and send email with attachment
      const emailRes = await fetch(`${API_BASE_URL}/api/send-email-with-pdf`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          from: "sa@bteb.gov.bd",
          to: emailRecipients,
          cc: "mahfujhassan14@gmail.com",
          subject: `Bangladesh Technical Education Board SIM replacement ${formData.contact_number}`,
          message: `
        জনাব,<br><br>
        আপনার আবেদনটি সফলভাবে জমা হয়েছে। সংযুক্ত PDF ফাইলটিতে আপনার আবেদনের বিস্তারিত তথ্য রয়েছে।<br><br>
        আবেদনের বিষয়: ${formData.applicant_subject === 'new_sim' ? 'নতুন ইআইআইএন সিম উত্তোলন' : 
                       formData.applicant_subject === 'eiin_sim_replacement' ? 'পুরাতন ইআইআইএন সিম রিপ্লেসমেন্ট' : 
                       'হারানো সিম উত্তোলন'}<br>
        আবেদনকারীর নাম: ${formData.applicant_name}<br>
        মোবাইল নম্বর: ${formData.mobile_no}<br>
        ইমেইল: ${formData.email}<br><br>
        ধন্যবাদান্তে,<br>
        বাংলাদেশ কারিগরি শিক্ষা বোর্ড
      `,
          applicationId: data.applicationId,
          inst_name: formData.inst_name,
          inst_code: formData.inst_code,
          inst_eiin: formData.inst_eiin
        })
      });

      const emailData = await emailRes.json();

      // REMOVE setIsLoading(false) from here

      if (emailData.success) {
        // ✅ Hide loading FIRST, THEN show confirm dialog
        setIsLoading(false);
        
        const userConfirmed = window.confirm(
          "আবেদনকারীকে আবেদনপত্র, NID ও জিডি (প্রযোজ্যক্ষেত্রে) নিয়ে নিকটস্থ গ্রামীণফোন সেন্টারে যোগাযোগ করার জন্য অনুরোধ করা হলো।\n\n" +
          "আবেদনটি সফলভাবে জমা হয়েছে।\n" +
          "OK ক্লিক করলে প্রিন্ট পৃষ্ঠায় যাবেন।"
        );
        
        if (userConfirmed) {
          navigate(`/print/${data.applicationId}`);
        }
      } else {
        // ✅ Hide loading FIRST, THEN show confirm dialog
        setIsLoading(false);
        
        const userConfirmed = window.confirm(
          "ইমেইল পাঠানো সম্ভব হয়নি, পুনরায় চেষ্টা করুন \n\n" 
        );
        
        if (userConfirmed) {
          navigate(`/simApp`);
        }
      }

    } catch (err) {
      // ✅ Hide loading on error
      setIsLoading(false);
      console.error("Error:", err);
      alert("একটি সমস্যা হয়েছে। দয়া করে আবার চেষ্টা করুন।");
    }
  };

  // Add logout function for institute users
  const handleLogout = () => {
    // Clear all authentication data
    localStorage.removeItem("auth");
    localStorage.removeItem("instituteData");
    localStorage.removeItem("currentView");
    localStorage.removeItem("tempInstituteData");
    localStorage.removeItem("isAdminViewingTemp");
    navigate("/");
  };

  return (
    <>
      <Header />
      <div>
        {/* ✅ Loading Overlay */}
        {isLoading && (
          <div className="loading-overlay">
            <div className="loading-spinner">
              <div className="spinner"></div>
              <p className="loading-text">আবেদন জমা হচ্ছে... দয়া করে অপেক্ষা করুন</p>
              <p className="loading-subtext">এটি কিছু সময় নিতে পারে</p>
            </div>
          </div>
        )}
        
        <div className="container">
          {/* Add logout button at top right */}
          
          <div className="form-box">
            <h3>প্রতিষ্ঠানভিত্তিক সিম উত্তোলন বা রিপ্লেসমেন্টের আবেদন ফর্ম</h3>

            <form onSubmit={handleSubmit}>
            {/* Application Subject */}
            <div className="form-group">
              <label>আবেদনের বিষয় *</label>
              <select
                name="applicant_subject"
                value={formData.applicant_subject}
                onChange={handleChange}
                className={errors.applicant_subject ? "error" : ""}
              >
                <option value="">-- সিলেক্ট করুন --</option>
                <option value="new_sim">
                  নতুন ইআইআইএন সিম উত্তোলনের জন্য আবেদন
                </option>
                <option value="eiin_sim_replacement">
                  পুরাতন ইআইআইএন সিম রিপ্লেসমেন্টের জন্য আবেদন
                </option>
                <option value="lost_sim_reissue">
                  হারানো সিম উত্তোলনের জন্য আবেদন
                </option>
              </select>
              {errors.applicant_subject && (
                <div className="error-message">{errors.applicant_subject}</div>
              )}
            </div>

            <div className="form-group">
              <label>শিক্ষা প্রতিষ্ঠানের নাম & কোড *</label>
              <input
                type="text"
                value={`${formData.inst_name} (${formData.inst_code})`}
                readOnly
              />
            </div>

            <div className="form-group">
              <label>প্রতিষ্ঠান ভিত্তিক সিম নম্বর *</label>
              <input
                type="text"
                value={formData.contact_number}
                readOnly
              />
            </div>

            <div className="form-group">
              <label>আবেদনকারীর নাম *</label>
              <input
                type="text"
                name="applicant_name"
                value={formData.applicant_name}
                onChange={handleChange}
                className={errors.applicant_name ? "error" : ""}
              />
              {errors.applicant_name && (
                <div className="error-message">{errors.applicant_name}</div>
              )}
            </div>

            <div className="form-group">
              <label>আবেদনকারীর পদবি *</label>
              <input
                type="text"
                name="designation"
                value={formData.designation}
                onChange={handleChange}
                className={errors.designation ? "error" : ""}
              />
              {errors.designation && (
                <div className="error-message">{errors.designation}</div>
              )}
            </div>

            <div className="form-group">
              <label>আবেদনকারীর মোবাইল নম্বর *</label>
              <input
                type="text"
                name="mobile_no"
                value={formData.mobile_no}
                onChange={handleChange}
                placeholder="01XXXXXXXXX"
                className={errors.mobile_no ? "error" : ""}
              />
              {errors.mobile_no && (
                <div className="error-message">{errors.mobile_no}</div>
              )}
            </div>

            {/* New Email Field */}
            <div className="form-group">
              <label>আবেদনকারীর ইমেইল *</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="example@domain.com"
                className={errors.email ? "error" : ""}
              />
              {errors.email && (
                <div className="error-message">{errors.email}</div>
              )}
            </div>

            {/* Applicant Photo */}
            <div className="form-group">
              <label>আবেদনকারীর ছবি *</label>
              <div className="upload-box">
                <input
                  type="file"
                  id="image"
                  accept="image/*"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setFormData({ ...formData, image: file });
                      if (errors.image) setErrors({ ...errors, image: "" });
                    }
                  }}
                />
                <label htmlFor="image" className="upload-label">
                  {formData.image ? "📷 Change Photo" : "📷 Click or Drag to Upload"}
                </label>
              </div>
              {errors.image && (
                <div className="error-message">{errors.image}</div>
              )}
              {formData.image && (
                <>
                  <div className="file-name">{formData.image.name}</div>
                  <div className="preview-card">
                    <img src={URL.createObjectURL(formData.image)} alt="Applicant Preview" className="preview-img" />
                  </div>
                </>
              )}
            </div>

            {/* NID Number */}
            <div className="form-group">
              <label>আবেদনকারীর এন.আই.ডি *</label>
              <input
                type="text"
                name="nid_no"
                value={formData.nid_no}
                onChange={handleChange}
                placeholder="৬-১৭ ডিজিটের এন.আই.ডি নম্বর"
                className={errors.nid_no ? "error" : ""}
              />
              {errors.nid_no && (
                <div className="error-message">{errors.nid_no}</div>
              )}
            </div>

            {/* NID Image */}
            <div className="form-group">
              <label>এন.আই.ডি এর ছবি উভয়পীঠ একত্রে *</label>
              <div className="upload-box">
                <input
                  type="file"
                  id="nid_image"
                  accept="image/*"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setFormData({ ...formData, nid_image: file });
                      if (errors.nid_image) setErrors({ ...errors, nid_image: "" });
                    }
                  }}
                />
                <label htmlFor="nid_image" className="upload-label">
                  {formData.nid_image ? "🪪 Change NID Photo" : "🪪 Click or Drag to Upload"}
                </label>
              </div>
              {errors.nid_image && (
                <div className="error-message">{errors.nid_image}</div>
              )}
              {formData.nid_image && (
                <>
                  <div className="file-name">{formData.nid_image.name}</div>
                  <div className="preview-card">
                    <img src={URL.createObjectURL(formData.nid_image)} alt="NID Preview" className="preview-img" />
                  </div>
                </>
              )}
            </div>

            {/* Conditional rendering of GD copy upload */}
            {formData.applicant_subject === "lost_sim_reissue" && (
              <div className="form-group">
                <label>GD কপি (PDF আপলোড) *</label>
                <div className="upload-box">
                  <input
                    type="file"
                    id="gd_image"
                    accept="application/pdf"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        setFormData({ ...formData, gd_image: file });
                        if (errors.gd_image) setErrors({ ...errors, gd_image: "" });
                      }
                    }}
                  />
                  <label htmlFor="gd_image" className="upload-label">
                    {formData.gd_image ? "📄 Change GD Copy (PDF)" : "📄 Click or Drag to Upload PDF"}
                  </label>
                </div>
                {errors.gd_image && (
                  <div className="error-message">{errors.gd_image}</div>
                )}
                {formData.gd_image && (
                  <>
                    <div className="file-name">{formData.gd_image.name}</div>
                    <div className="preview-card">
                      <embed
                        src={URL.createObjectURL(formData.gd_image)}
                        type="application/pdf"
                        width="100%"
                        height="100%"
                      />
                    </div>
                  </>
                )}
              </div>
            )}

              <button 
                type="submit" 
                className="btn btn-green btn-submit"
                disabled={isLoading} // ✅ Disable button when loading
              >
                {isLoading ? (
                  <>
                    <span className="spinner-small"></span>
                    আবেদন জমা হচ্ছে...
                  </>
                ) : (
                  "আবেদন জমা দিন ও ইমেইল পাঠান"
                )}
              </button>
          </form>
        </div>
      </div>
    </div>
    <Footer/>
    </>
  );
}